import React from "react";
import { TextField, FormControl } from "@mui/material";
import { Field, getIn } from "formik";
import has from "lodash/has";

const FormTextField = ({
  name = "",
  label,
  helperText = "",
  children,
  disabled,
  onChange,
  type = "text",
  fullWidth = true,
  multiline = false,
  placeholder = "",
  size = "small",
  InputProps,
  inputProps,
  noLabel = false,
  ...rest
}) => {
  const id = name;
  const handleChange = (formikOnChange) => (e) => {
    if (onChange) {
      onChange(e);
    }
    formikOnChange(e);
  };
  return (
    <Field name={name}>
      {({
        field: { value, onChange: formChange, onBlur },
        form: { errors, touched },
      }) => {
        return (
          <TextField
            id={id}
            name={name}
            value={value}
            onChange={handleChange(formChange)}
            onBlur={onBlur}
            color="primary"
            fullWidth={fullWidth}
            autoComplete="off"
            multiline={multiline}
            label={!noLabel && label}
            variant="outlined"
            type={type}
            inputProps={{
              ...inputProps,
              maxLength: inputProps?.maxLength ?? (multiline ? undefined : 450),
            }}
            placeholder={placeholder}
            disabled={disabled}
            size={size}
            InputProps={InputProps}
            InputLabelProps={{
              shrink: true,
            }}
            error={has(errors, id) && has(touched, id)}
            helperText={
              has(errors, id) && has(touched, id)
                ? getIn(errors, id)
                : helperText
            }
            {...rest}
          >
            {children}
          </TextField>
        );
      }}
    </Field>
  );
};

export default FormTextField;
